<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
<!--                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchData">-->
<!--                    <input-->
<!--                        class="form-control mr-sm-2"-->
<!--                        type="search"-->
<!--                        v-model="search.code"-->
<!--                        placeholder="รหัสสินค้า"-->
<!--                        aria-label="Search"/>-->
<!--                    <select class="form-control" v-model="search.type">-->
<!--                        <option-->
<!--                            v-for="options in optionProductType"-->
<!--                            :value="options.value">{{ options.text }}</option>-->
<!--                    </select>-->
<!--                    &nbsp; &nbsp;-->
<!--                    <button-->
<!--                        class="btn btn-success my-2 my-sm-0"-->
<!--                        type="button"-->
<!--                        @click="searchData">-->
<!--                        <icon name="search"></icon> ค้นหา-->
<!--                    </button>-->
<!--                    &nbsp&nbsp-->
<!--                    <template v-if="canInventoryProductsUpdate">-->
<!--                        <router-link to="/products-information">-->
<!--                            <button-->
<!--                                    class="btn btn-warning my-2 my-sm-0"-->
<!--                                    type="button">-->
<!--                                <icon name="plus"></icon>-->
<!--                                เพิ่มสินค้า-->
<!--                            </button>-->
<!--                        </router-link>-->
<!--                    </template>-->
<!--                    &nbsp&nbsp-->
                    &nbsp&nbsp
                    <button @click="showImportModal"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon> นำเข้าไฟล์
                    </button>
                    &nbsp&nbsp
                    <button @click="showExportModal"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon> นำออกไฟล์
                    </button>
<!--                </form>-->
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อไฟล์</th>
                    <th scope="col">ดูไฟล์</th>
                    <th scope="col">หมวดหมู่</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">วันที่มีผล</th>
                    <th scope="col">ผู้ใช้งาน</th>
                    <th scope="col">วันที่นำเข้า/ออก</th>
                    <th scope="col">การใช้งาน</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,i) in productsList">
                    <td>
                        {{((dataPaginate.current_page-1)*40)+(i+1)}}
                    </td>
                    <td>
                        {{data.filename}}
                    </td>
                    <td>
                        <button @click="downloadExcel(data.filepath)"
                                class="btn btn-primary my-2 my-sm-0"
                                type="button">
                            <icon name="print"></icon> ดูไฟล์
                        </button>
                    </td>
                    <td>
                        <template v-if="data.producttype.length > 0">
                            <template v-for="(row,index) in data.producttype">
                                {{(data.producttype.length==index+1?row.name:row.name+',')}}
                            </template>
                        </template>
                        <template v-else>
                            ทั้งหมด
                        </template>
<!--                        {{data.producttype?data.product_type.name:'ทั้งหมด'}}-->
                    </td>
                    <td>
                        <template v-if="data.status == 1">
                            <span style="color:green;">Active</span>
                        </template>
                        <template v-else>
                            <span style="color: red">InActive</span>
                        </template>
                    </td>
                    <td>
                        {{data.date?data.date:'-'}}
                    </td>
                    <td>
                        {{data.user.name}}
                    </td>
                    <td>
                        {{data.created_at}}
                    </td>
                    <td>
                        <template v-if="data.is_type">
                            นำเข้า
                        </template>
                        <template v-else>
                            นำออก
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--pagination--->
        <div v-if="productsList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getProductsPage">
            </vue-pagination>
        </div>
        <!--  Modal loading -->
        <b-modal hide-header hide-footer ref="loading">
            <loading :status="status" :msg="msg" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!-- Modal import products -->
        <b-modal
            hide-footer
            ref="import_data"
            title="นำเข้าไฟล์">
            <div class="row">
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    ไฟล์ข้อมูล
                </label>
                <div class="col-sm-6">
                    <input ref="fileupload" type="file" @change="FileExcel">
                </div>
            </div>
            <div class="row">
                <label class="offset-sm-2 col-sm-10 col-form-label text-capitalize text-left" style="color: red;font-size: 12px">
                    **ถ้าต้องการให้มีผลเลยไม่ต้องใส่วันที่
                </label>
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    วันที่มีผล
                </label>
                <div class="col-sm-6">
                    <date-picker
                        v-model="date"
                        type="date"
                        format="DD/MM/YYYY"
                        :lang="lang"
                        class="w-100"
                        placeholder="เลือกวันที่" >
                    </date-picker>
                </div>
            </div>
            <div style="text-align: center;">
            <button @click="importExcel"
                    type="button"
                    class="btn btn-success">
                ตกลง</button>
        </div>
        </b-modal>
<!--         Modal Export Products-->
        <b-modal
            hide-footer
            ref="export_data"
            title="นำออกไฟล์">
            <div class="row">
                <label class="offset-sm-1 col-sm-10 col-form-label text-capitalize text-left" style="color: red;font-size: 12px">
                    **ถ้าต้องการทั้งหมด ไม่ต้องเลือกประเภทสินค้า
                </label>
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    ประเภทสินค้า
                </label>
                <div class="col-sm-6">
                    <multiselect
                        v-model="product_type_selecte"
                        :options="product_type"
                        track-by="id"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :custom-label="LabelName"
                        placeholder="เลือกประเภทสินค้า">
                    </multiselect>
                </div>
            </div>
            <br />
            <div style="text-align: center;">
                <button @click="exportExcel"
                        type="button"
                        class="btn btn-success">
                    ตกลง</button>
            </div>

        </b-modal >
<!--        <b-modal hide-header hide-footer ref="print_product_price">-->
<!--            <add-price-product-modal @submit="printProductPrice"></add-price-product-modal>-->
<!--        </b-modal>-->
        <!--<pre class="alert alert-primary">{{ product }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";
import ImportData from "../Import/ImportData";
import ExportData from "../Export/ExportData";
import VuePagination from "../../Pagination";
import { domain } from "../../../util/Constants";
import AddPriceProductModal from "../../Order/Overview/AddPriceProductModal";
import DatePicker from 'vue2-datepicker'

import {
    canInventoryProductsImport,
    canInventoryProductsExport,
    canInventoryProductsPriceView,
    canInventoryProductsDetailView,
    canInventoryProductsUpdate
} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "products-stock-list",
    components: {
        Loading,
        VuePagination,
        ExportData,
        ImportData,
        FormTextarea,
        Multiselect,
        AddPriceProductModal,
        DatePicker
    },
    data() {
        return {
            msg : '',
            status : '',
            // id: "",
            // option: [{ text: "หมวดหมู่สินค้า", value: "" }],
            event_submit : false,
            product_type : [],
            product_type_selecte : [],
            import_excel : [],
            date : "",
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        // this.$store.dispatch("Products/clearSearch");
        this.$store.dispatch("Products/setProductsStock",1);
        this.$store.dispatch('ProductType/get').then(res=>{
            this.product_type = res;
        });
    },
    computed: {
        canInventoryProductsImport,
        canInventoryProductsExport,
        canInventoryProductsPriceView,
        canInventoryProductsDetailView,
        canInventoryProductsUpdate,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            productsList: state=>{
                return state.Products.productsList
            },
            dataPaginate : state=>{
                return state.Products.dataPaginate
            }
        })
    },
    methods: {
        exportExcel() {
            let category = '';
            this.product_type_selecte.forEach((data,index)=>{
                category+=this.product_type_selecte.length==index+1?data.id:data.id+',';
            });
            this.hideExportModal();
            this.$store.dispatch('Products/setProductsStock',1)
            window.open( `${domain}/products-stock-log-export?category=${category}&user_id=${this.user.id}`);
        },
        importExcel() {
            if(this.import_excel){
                let formData = new FormData();
                formData.append('file',this.import_excel);
                formData.append('user_id',this.user.id);
                formData.append('date',this.date?this.date:'');
                this.$store.dispatch('Products/importExcel',formData).then(()=>{
                    this.hideImportModal();
                    this.getProductsPage();
                });
                this.hideImportModal();
            }
        },
        FileExcel(event) {
            this.import_excel = event.target.files[0];
        },
        LabelName (option) {
            return `${option.type_code} - ${option.name}`
        },
        showExportModal() {
            this.product_type_selecte = [];
            this.$refs.export_data.show();
        },
        hideExportModal() {
            this.$refs.export_data.hide();
        },
        showImportModal() {
            this.import_excel = [];
            this.$refs.fileupload.value=null
            this.$refs.import_data.show();
        },
        hideImportModal() {
            this.$refs.export_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        downloadExcel(filePath) {
            let url = 'https://sbpack.co/somboon/public/storage/excel/'+filePath;
            window.open(url);
        },
        getProductsPage(){
            const page = this.dataPaginate.current_page;
            //paginate search
            if(this.event_submit){
                // this.$store.dispatch('Products/search',{
                //     page : page,
                //     code: this.search.code,
                //     type: this.search.type
                // }).then(()=>{
                //     this.hideLoadingModal();
                // });
            }else{
                //paginate get data
                this.$store.dispatch('Products/setProductsStock',page)
            }
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
